/**
* this is the top bar component for the dashboard
*
* Created by Tom on 24/05/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// action import
import { ActionCreator } from '../../actions/'

// component import
import TopBarMenuItem from '../TopBarMenuItem/'

// top bar menu items import
import menuItems from './menuItems'

// icon imports
import Logo from '../../assets/svg/selfmade_logo.svg'
import AvatarIcon from '../../assets/svg/avatar.svg'
import ArrowIcon from '../../assets/svg/arrow_blue.svg'
import LockIcon from '../../assets/svg/lock.svg'
import Hamburger from '../../assets/svg/hamburger.svg'

// style import
import './style.scss'


class TopBar extends Component {

    _onMenuItemClick(route) {
        const { goToRoute } = this.props
        // go to either an internal or external route
        goToRoute(route)
    }

    _onHamburgerClick() {
        const { setOpenLeftMenu } = this.props
        // open the left menu
        setOpenLeftMenu(true)
    }

    render() {

        const { pathname } = this.props

        return (
            <div className="top-bar">

                {/* selfmade superfund logo */}
                <img
                    src={Logo}
                    className="top-bar__logo"
                    alt="Selfmade superfund logo" />

                {/* topbar menu items and icons */}
                <div className="top-bar__menu-items">

                    <TopBarMenuItem
                        menuItem={menuItems[0]}
                        pathname={pathname}
                        onClick={::this._onMenuItemClick}
                    />

                    <TopBarMenuItem
                        menuItem={menuItems[1]}
                        pathname={pathname}
                        onClick={::this._onMenuItemClick}
                    />

                    <TopBarMenuItem
                        menuItem={menuItems[2]}
                        pathname={pathname}
                        onClick={::this._onMenuItemClick}
                    />

                    <div className="top-bar__menu-items__icon-wrapper-left">

                        <TopBarMenuItem
                            menuItem={menuItems[3]}
                            pathname={pathname}
                            onClick={::this._onMenuItemClick}
                            leftIcon={AvatarIcon}
                            leftIconClass={"top-bar__menu-items__icon-wrapper-left__acc"}
                            leftIconAlt="Avatar icon"
                            rightIcon={ArrowIcon}
                            rightIconClass="top-bar__menu-items__icon-wrapper-left__arrow"
                            rightIconAlt="Arrow icon"
                        />

                        <TopBarMenuItem
                            menuItem={menuItems[4]}
                            pathname={pathname}
                            onClick={::this._onMenuItemClick}
                            leftIcon={LockIcon}
                            leftIconClass="top-bar__menu-items__icon-wrapper-left__lock"
                            leftIconAlt="Lock icon"
                        />

                    </div>

                </div>

                {/* hamburger icon */}
                <img
                    src={Hamburger}
                    className="top-bar__hamburger"
                    alt="Mobile view hamburger icon"
                    onClick={::this._onHamburgerClick}/>
            </div>
        )
    }
}

// define the prop types
TopBar.propTypes = {
    setOpenLeftMenu: PropTypes.func.isRequired,
    goToRoute: PropTypes.func.isRequired,
    pathname: PropTypes.string
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        pathname: state.router.location.pathname
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenLeftMenu: action.setOpenLeftMenu,
        goToRoute: action.goToRoute
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopBar)



// WEBPACK FOOTER //
// ./src/components/TopBar/index.js